import { createSlice } from '@reduxjs/toolkit';
import { getHomepage } from './homeAction';

const initialState = {
  homepageData: null,
  isLoading: false,
  error: null,
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    clearHomeError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHomepage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getHomepage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.homepageData = action.payload;
      })
      .addCase(getHomepage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearHomeError } = homeSlice.actions;
export default homeSlice.reducer;
